// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import CreditCard20 from './CreditCard20.tsx';
import CreditCard20Circle from './CreditCard20Circle.tsx';
import CreditCard24 from './CreditCard24.tsx';
import CreditCard24Circle from './CreditCard24Circle.tsx';
import CreditCard40 from './CreditCard40.tsx';
import CreditCard40Circle from './CreditCard40Circle.tsx';

type CreditCardProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '40Circle';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    CreditCard20,
    CreditCard20Circle,
    CreditCard24,
    CreditCard24Circle,
    CreditCard40,
    CreditCard40Circle,
};

const CreditCard: FC<CreditCardProps> = ({ variation, ...props }) => {
    const variationKey = `CreditCard${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"CreditCard" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default CreditCard;
